<template>
  <div id="login-page" class="page-wrapper d-flex flex-column">
    <div
      class="d-flex flex-row login-header justify-content-center align-items-center"
    >
      <div
        class="col-8 col-md-3 col-xl-12 d-flex justify-content-center align-items-center my-4 mb-md-4 mb-2"
      >
        <img
          class="img-fluid"
          src="../assets/images/winning_form-logo_black.png"
        />
      </div>
    </div>

    <div
      v-if="loginStates.siteSelection"
      class="row no-gutters justify-content-center align-items-md-center login-body mt-5"
    >
      <div
        class="col-11 col-md-5 login-modal login animated2s fadeIn py-1 px-1"
      >
        <h4 class="header-text mt-2 mb-md-2">SITE SELECTION</h4>
        <span class="px-3 header-subtext row justify-content-center"
          >Choose between the new and the old Winning Form, please select your
          preferred view.</span
        >
        <div
          class="row no-gutters align-items-center justify-content-center mx-4 my-4"
        >
          <img
            :src="getImage('site-selection-new', 'svg')"
            v-on:click="navigateToNewSite('login')"
            class="site-selection col-5 clickable-item"
          />
          <span class="col-1 text mx-2 or-text">OR</span>
          <img
            :src="getImage('site-selection-old', 'svg')"
            v-on:click="navigateToOldSite('login')"
            class="site-selection col-5 clickable-item"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { LoginService } from "../services/login.service";
import {
  email,
  integer,
  maxLength,
  minLength,
  numeric,
  required,
  requiredIf,
  sameAs,
} from "vuelidate/lib/validators";

export default {
  name: "Login",
  validations: {
    resetPasswordModel: {
      cell: {
        integer,
      },
      email: {
        email,
      },
      IdNumber: {
        required,
      },
    },
    registrationModel: {
      titleId: {
        required,
      },
      initials: {
        required,
      },
      firstName: {
        required,
        minLength: minLength(2),
      },
      lastName: {
        required,
        minLength: minLength(2),
      },
      gender: {
        required,
      },
      identityNumber: {
        required: requiredIf(function () {
          return this.identityUsed.idNumber;
        }),
        integer,
        minLength: minLength(13),
        maxLength: maxLength(13),
      },
      dateOfBirth: {
        required: requiredIf(function () {
          return this.identityUsed.passportNumber;
        }),
      },
      cell: {
        required,
        minLength: minLength(10),
        maxLength: maxLength(10),
        integer,
      },
      email: {
        required,
        email,
      },
      countryId: 0,
      password: {
        required,
        minLength: minLength(4),
      },
      sourceOfIncome: {
        required,
      },
      postalAddress: {
        suburb: {
          required,
        },
        city: {
          required,
        },
        code: {
          required,
          minLength: minLength(4),
          integer,
        },
        regionId: {
          required,
        },
        lineOne: {
          required,
          minLength: minLength(4),
        },
      },
      settings: {
        emailNotifications: {},
        emailPromotions: {},
        fractionalOdds: {},
      },
      agreements: {
        agreeToAgePolicy: {
          sameAs: sameAs(() => true),
        },
        agreeToTermsAndConditions: {
          sameAs: sameAs(() => true),
        },
        agreeToAcknowledge: {
          sameAs: sameAs(() => true),
        },
      },
      referAFriend: {
        numeric,
      },
    },
  },
  data: function () {
    return {
      themeStyles: {
        wrapper: {
          border: "1",
        },
        header: {
          color: "#fafafa",
          backgroundColor: "#000000",
          borderColor: "#404c59",
          borderWidth: "1px 1px 0 1px",
        },
        headerVerticalDivider: {
          borderLeft: "1px solid #404c59",
        },
        weekdays: {
          color: "#ffffff",
          backgroundColor: "#000000",
          borderColor: "#4C4C4C",
          borderWidth: "0 1px",
          padding: "5px 0 10px 0",
        },
        weekdaysVerticalDivider: {
          borderLeft: "1px solid #404c59",
        },
        weeks: {
          border: "1px solid #dadada",
          backgroundColor: "#FFFFFF",
        },
      },
      loginResponseMessage: "",
      loginModel: {
        username: "",
        password: "",
      },
      registerResponseMessage: "",
      forgotPasswordResponseMessage: "",
      loginStates: {
        login: false,
        register: false,
        forgotPassword: false,
        registrationComplete: false,
        forgotPasswordComplete: false,
        siteSelection: true,
      },
      identityUsed: {
        idNumber: true,
        passportNumber: false,
      },
      genders: {
        male: true,
        female: false,
      },
      sourcesOfIncome: [
        "Salary",
        "Self Employed",
        "Inheritance",
        "Savings",
        "Investment",
      ],
      resetPasswordMethod: {
        sms: true,
        email: false,
      },
      resetPasswordModel: {
        cell: "",
        email: "",
        idNumber: "",
      },
      registrationModel: {
        titleId: 5,
        initials: "",
        firstName: "",
        lastName: "",
        gender: "male",
        passport: "",
        identityNumber: "",
        dateOfBirth: new Date(),
        cell: "",
        email: "",
        countryId: 0,
        password: "",
        sourceOfIncome: "Salary",
        physicalAddress: {
          lineOne: "",
          lineTwo: "",
          suburb: "",
          city: "",
          code: "",
          regionId: 3,
        },
        postalAddress: {
          lineOne: "",
          lineTwo: "",
          suburb: "",
          city: "",
          code: "",
          regionId: 3,
        },
        agreements: {
          agreeToAgePolicy: false,
          agreeToTermsAndConditions: false,
          agreeToAcknowledge: false,
        },
        settings: {
          emailNotifications: false,
          emailPromotions: false,
          fractionalOdds: true,
        },
        referrerUrl: "",
        promotionId: 0,
        depositLimitPerDay: 0,
        referAFriend: "",
      },
      registrationOptions: {},
    };
  },
  computed: {
    inputState() {
      if (!this.selectedValue) {
        return {
          type: "is-danger",
          message: "Date required.",
        };
      }
      return {
        type: "is-primary",
        message: "",
      };
    },
    ...mapState(["userAuthToken"]),
  },
  methods: {
    openPage(url) {
      window.open(url, "_blank");
    },

    openPage(url) {
      window.open(url, "_blank");
    },

    getImage(imagePath, fileType = "svg") {
      return require("../assets/images/" + imagePath + "." + fileType);
    },
    async setLoginState(stateName) {
      for (let state in this.loginStates) {
        if (this.loginStates[state] && stateName === state) return;
        if (stateName === "register" && state === "register") {
          this.registrationOptions =
            await LoginService.getRegistrationOptions();
          this.loginStates[state] = state === stateName;
        } else {
          this.loginStates[state] = state === stateName;
        }
      }
    },
    msieversion() {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");
      if (msie > 0) {
        // IE 10 or older
        return alert("For better experience Please Use Chrome");
      }

      var trident = ua.indexOf("Trident/");
      if (trident > 0) {
        // IE 11
        return alert("For better experience Please Use Chrome");
      }

      var edge = ua.indexOf("Edge/");
      if (edge > 0) {
        // Edge (IE 12+)

        return alert("For better experience Please Use Chrome");
      }
    },
    toggleIdentityUsed(identity) {
      for (let identityType in this.identityUsed) {
        if (this.identityUsed[identityType] && identity === identityType)
          return;
        this.identityUsed[identityType] = identityType === identity;
      }
    },
    toggleGender(gender) {
      for (let genderType in this.genders) {
        if (this.genders[genderType] && gender === genderType) return;
        this.genders[genderType] = genderType === gender;
        this.registrationModel.gender = gender;
      }
    },
    toggleOdds(fractionalOdds) {
      this.registrationModel.settings.fractionalOdds = fractionalOdds;
    },
    toggleForgotPasswordMethod(method) {
      for (let resetPasswordMethod in this.resetPasswordMethod) {
        if (
          this.resetPasswordMethod[resetPasswordMethod] &&
          method === resetPasswordMethod
        )
          return;
        this.resetPasswordMethod[resetPasswordMethod] =
          resetPasswordMethod === method;
      }
    },
    onLoginClicked() {
      LoginService.login(
        this.loginModel.username,
        this.loginModel.password,
        this.onLoginResponse.bind(this)
      );
    },
    navigateToNewSite() {
      this.$router.push("/landing/home");
    },
    navigateToOldSite() {
      window.open(`https://legacy.winningform.co.za/`, "_self");
    },
    transformApiResponseIntoAccessToken(item) {
      return {
        type: item.type,
        token: item.token,
        expiryDateTimeUTC: new Date(item.expiryDateTimeUTC),
      };
    },
    transformLoginResponse(loginResponse) {
      let basic = loginResponse.punter.basic || loginResponse.punter;
      basic.punterId = basic.punterId || basic.id;
      let identity = basic.identity;
      let account = loginResponse.punter.account;
      account.balance = account.balance || account;
      account.maxLiability = account.maxLiability || {
        single: 0,
        multiple: 0,
        open: 0,
      };
      account.responsibleBetting = account.responsibleBetting || {
        deposit: 0,
        stake: 0,
        selfExclusionDate: null,
      };
      return {
        accessToken: this.transformApiResponseIntoAccessToken(
          loginResponse.accessToken
        ),
        betgamesToken: loginResponse.betGamesAccessToken,
        requiresPasswordReset: loginResponse.requiresPasswordReset,
        passwordChangeUrl: loginResponse.passwordChangeUrl,
        punter: {
          id: basic.punterId,
          title: basic.title,
          initials: basic.initials,
          firstName: basic.firstName,
          lastName: basic.lastName,
          gender: basic.gender,
          dateOfBirth: basic.dateOfBirth,
          identity: {
            typeId: identity.typeId,
            type: identity.type,
            value: identity.value,
          },
          branchId: basic.branchId,
          countryId: basic.countryId,
          account: {
            typeId: account && account.typeId,
            type: account && account.type,
            creditLimit: account && account.creditLimit,
            depositLimit: account && account.depositLimit,
            ficaCompliant: account && account.ficaCompliant,
            balance: {
              available:
                account && account.balance && account.balance.available,
              pending: account && account.balance && account.balance.pending,
            },
          },
          maximumLiability: {
            single: account.maxLiability.single,
            multiple: account.maxLiability.multiple,
            openStake: account.maxLiability.open,
          },
          respBetting: {
            dailyDepositLimit:
              account &&
              account.respBetting &&
              account.respBetting.depositLimit,
            dailyBetStakeLimit:
              account && account.respBetting && account.respBetting.stakeLimit,
            selfExclusionDate:
              account &&
              account.respBetting &&
              account.respBetting.selfExclusionDate,
          },
        },
      };
    },
    setRememberMeSsoCookie(response, currentDate) {
      const loginResponse = this.transformLoginResponse(response);
      const encodedResponse = encodeURIComponent(JSON.stringify(loginResponse));
      let hostName = window.location.hostname;
      //let hostName = ".hollywoodbets.net";
      hostName = hostName.substring(
        hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1) + 1
      );
      document.cookie = `rememberMe=${encodedResponse}; expires=${currentDate.toGMTString()}; path=/; domain=${hostName};`;
    },
    onLoginResponse(responseObject, error) {
      if (error) {
        this.loginResponseMessage = error;
      } else {
        const currentDate = new Date();
        currentDate.setTime(currentDate.getTime() + 43200 * 1000);

        this.setUserAuthToken(responseObject.accessToken.token);
        this.setPunterData(responseObject.punter);
        this.setRememberMeSsoCookie(responseObject, currentDate);

        document.cookie = "token=" + responseObject.accessToken.token;
        document.cookie = "punterData=" + responseObject.punter.basic.punterId;
        this.setLoginState("siteSelection");
      }
    },
    async submitResetPassword() {
      const response = await LoginService.resetPassword(
        this.resetPasswordModel
      );
      if (response.data.responseType === -1) {
        this.forgotPasswordResponseMessage = response.data.responseMessage;
      } else {
        this.setLoginState("forgotPasswordComplete");
      }
    },
    async onRegisterClicked() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const yearSubstring = this.registrationModel.identityNumber.substring(
          0,
          2
        );
        const monthSubstring =
          this.registrationModel.identityNumber.substring(2, 4) - 1;
        const daySubstring = this.registrationModel.identityNumber.substring(
          4,
          6
        );
        const DOB = this.identityUsed.idNumber
          ? new Date(yearSubstring, monthSubstring, daySubstring)
          : this.registrationModel.dateOfBirth;

        const date = DOB.getDate() < 10 ? `0${DOB.getDate()}` : DOB.getDate();
        const month =
          DOB.getMonth() < 10 ? `0${DOB.getMonth() + 1}` : DOB.getMonth() + 1;
        const year = DOB.getFullYear();

        this.registrationModel.dateOfBirth =
          year + "-" + month + "-" + date + "T12:00Z";
        const response = await LoginService.registerUser(
          this.registrationModel
        );
        if (response.data.responseType === -1) {
          this.registerResponseMessage = response.data.responseMessage;
        } else {
          this.setLoginState("registrationComplete");
        }
      }
    },
    ...mapMutations(["setUserAuthToken", "setPunterData"]),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#login-page {
  background: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/1385871/login-background.jpg")
    no-repeat center center fixed;
  min-width: 100vw;
  min-height: 100vh;
}

.login h1,
.login h2,
.login {
  text-align: center;
}

.login-modal {
  border: solid 2px rgba(255, 255, 255, 1);
  background-color: rgba(0, 0, 0, 0.85);
  border-radius: 0.5rem;
  z-index: 10;
  padding: 1rem;
  margin-bottom: 2rem;
}

h4 {
  font-weight: bolder;
}

.login-button {
  color: #ffffff;
  border: solid 2px white;
  border-radius: 0 !important;
  background: black;
  font-size: 1.2rem;
}

.header-subtext {
  font-size: 0.6rem;
  color: white;
}

.login-label {
  color: #ffffff;
  font-size: 1.4rem;
}

.login-input {
  color: #ffffff;
  border: 0;
  outline: 0;
  background: transparent;
  border-bottom: 1px solid white;
  border-radius: 0 !important;
}

.register-label {
  color: #ffffff;
  font-size: 1rem;
  text-align: left;
  padding: 0 !important;
}

.register-input {
  color: black;
  background: #ffffff;
  border: 1px solid black;
  border-radius: 5px !important;
}

.register-input::placeholder {
  text-align: center;
  color: #828282;
}

.button-selected {
  color: white !important;
  border: 2px solid white !important;
  border-radius: 5px !important;
  background-color: black !important;
}

.button-unselected {
  color: black;
  border: 2px solid black;
  border-radius: 5px;
  background-color: white;
  font-size: 0.8rem;
}

.toggle-button {
  width: 49%;
}

input[type="checkbox"] {
  vertical-align: middle;
  position: relative;
  bottom: 2px;
}

.checkbox-label {
  color: white;
  font-size: 0.9rem;
  margin-left: 0.6rem;
  text-align: left;
  word-wrap: break-word;
}

.submit-button {
  color: white;
  border: 2px solid black;
  border-radius: 5px;
  background-color: #5e2a95;
}

.close-button {
  position: absolute;
  top: 0.45rem;
  right: 0.45rem;
  width: 16px;
  height: 16px;
  color: white;
}

.dropdown-option {
  text-align-last: center;
  padding-right: 29px;
}

.forgot-password-toggle {
  height: 2rem;
}

@media (min-width: 1200px) {
  .or-text {
    font-size: 2rem;
  }

  #login-page {
    width: 100vw;
    height: 100vh;
    overflow-y: scroll;
  }

  .close-button {
    top: 0.8rem;
    right: 0.8rem;
    width: 25px;
    height: 25px;
  }

  .header-subtext {
    font-size: 0.9rem;
  }

  .button-unselected {
    font-size: 0.8rem;
  }

  .register-label {
    font-size: 1.4rem;
  }

  .login-label {
    font-size: 1.6rem !important;
  }

  .register-label {
    font-size: 1.4rem !important;
  }
}

.account-text {
  font-size: 1rem !important;
  text-decoration: underline;
}

.account-text:hover {
  cursor: pointer;
}

.c-day-content {
  text-shadow: none !important;
}
</style>
